/*
 * File: fascicle.resolver.ts                                                  *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 9th March 2022 14:41:17                            *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 2nd December 2022 14:22:16                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */



import { inject, Injectable } from '@angular/core';
import {
  ResolveFn
} from '@angular/router';
import { CatalogService } from '../services/catalog.service';

export const CatalogResolver: ResolveFn<any> = async (route, state) => {
  return inject(CatalogService).getBreadCrumb(route.paramMap.get("idCatalog"));
}
